import React from "react";
import {
  CalendarOutlined,
  NumberOutlined,
  PhoneOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./dropOffCard.css";

const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("") || "?";

const DropOffCard = ({ dropOff, onView }) => {
  const name = dropOff?.owner?.name || "Unknown user";
  const role = dropOff?.owner?.roles?.[0];
  const phone = dropOff?.owner?.phone;

  return (
    <div className="dropOffCard">
      <div className="dropOffCard__top">
        <div className="dropOffCard__user">
          <div className="dropOffCard__avatar">{initials(name)}</div>
          <div style={{ minWidth: 0 }}>
            <p className="dropOffCard__name">{name}</p>
            {role && <span className="dropOffCard__role">{role}</span>}
          </div>
        </div>
        {dropOff?.date_type && (
          <span className="dropOffCard__date">
            <CalendarOutlined />
            {dropOff.date_type}
          </span>
        )}
      </div>

      <div className="dropOffCard__bottom">
        <div className="dropOffCard__meta">
          {dropOff?.code && (
            <span>
              <NumberOutlined />
              <b>{dropOff.code}</b>
            </span>
          )}
          {phone && (
            <span>
              <PhoneOutlined />
              {phone}
            </span>
          )}
        </div>
        <div className="dropOffCard__actions">
          <button
            type="button"
            className="dropOffCard__view"
            onClick={() => onView(dropOff?.code)}
          >
            View <RightOutlined style={{ fontSize: "10px" }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DropOffCard;
